// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalInfo_container__q22oT","row":"PersonalInfo_row__3-_bw","attrCell":"PersonalInfo_attrCell__1cRP3","valueCell":"PersonalInfo_valueCell__2l_bI"};